/**
 * How far ahead the feed is asked for. Two days is enough to cover an overnight
 * gap — the last show of the evening ends and the next one is tomorrow morning.
 */
const FEED_DAYS = 2;

/** The feed 500s without both bounds, so they are always sent. */
export function scheduleFeedUrl(dayStart) {
  const end = new Date(
    dayStart.getFullYear(),
    dayStart.getMonth(),
    dayStart.getDate() + FEED_DAYS
  );
  const params = new URLSearchParams({
    start: dayStart.toISOString(),
    end: end.toISOString(),
  });

  return `${process.env.NEXT_PUBLIC_BASE_URL}/schedule/feed?${params}`;
}

/**
 * The feed returns every entry that falls in the window, including ones from
 * schedule blocks that aren't running — the calendar hides those in
 * `eventDidMount` rather than filtering the feed itself. An entry with no
 * ranges is treated as not running, which is what the calendar does too.
 */
export function isWithinRanges(entry) {
  const start = new Date(entry.start);
  const end = new Date(entry.end);

  return (entry.ranges || []).some((range) => {
    const rangeStart = new Date(range.start);
    const rangeEnd = new Date(range.end);
    return start < rangeEnd && end > rangeStart;
  });
}

/** The soonest show starting after `from`, or null. */
export function nextShow(entries, from) {
  if (!Array.isArray(entries)) return null;

  return (
    entries
      .filter((entry) => entry.start && entry.end && isWithinRanges(entry))
      .map((entry) => ({ ...entry, startsAt: new Date(entry.start) }))
      .filter((entry) => entry.startsAt > from)
      .sort((a, b) => a.startsAt - b.startsAt)[0] || null
  );
}

export function formatStartTime(date) {
  return new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}

